import apiClient from './apiClient'
import { LinkButton } from '../../model/LinkButton'

// Backend LinkResponse { id(UUID), position, url, title, thumbnail }
// → client LinkButton(uuid=id, id=position, title, url, thumbnail).
function toLinkButton(link) {
    return new LinkButton(link.id, link.position, link.title, link.url, link.thumbnail || "")
}

/** Links for a page (public endpoint), sorted by position server-side. */
export async function getLinkButtons(pageId) {
    const { data } = await apiClient.get(`/links/vp/${pageId}`)
    return (data || []).map(toLinkButton)
}

/** Adds a link; the backend assigns the id + position. Returns the created LinkButton. */
export async function addLinkButton(linkButton, pageId) {
    const body = { url: linkButton.url, title: linkButton.title, thumbnail: linkButton.thumbnail || "" }
    const { data } = await apiClient.post(`/links/${pageId}`, body)
    return toLinkButton(data)
}

/** Updates a link by its id (uuid). Returns the updated LinkButton. */
export async function updateLinkButton(linkButton) {
    const body = { url: linkButton.url, title: linkButton.title, thumbnail: linkButton.thumbnail || "" }
    const { data } = await apiClient.put(`/links/${linkButton.uuid}`, body)
    return toLinkButton(data)
}

/** Persists a new order as the ordered list of link ids. */
export async function reorderLinkButtons(pageId, orderedUuids) {
    await apiClient.put(`/links/${pageId}/order`, orderedUuids)
}

export async function deleteLinkButton(linkButtonId) {
    await apiClient.delete(`/links/${linkButtonId}`)
}
